<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 14/12/2022
  -->

<template>
	<div v-if="isDateTimePicker" class="qwoach-form qw-row qw-date-picker-root">
		<el-date-picker
			ref="datePicker"
			v-model="dateValue"
			v-bind="attrsDateCustom"
			class="qw-date-picker__date-select col px-0"
			:class="[{'pointer': !readonly, 'borderDotted': borderDotted, 'input-background': !hideInputBackground}]"
			type="date"
			:format="format"
			:readonly="readonly"
			:disabled="disabled"
			:placeholder="placeholder">
		</el-date-picker>
		<el-time-select
			ref="timePicker"
			class="qw-date-picker__time-select col px-0"
			:placeholder="placeholderTime"
			v-model="timeValue"
			:format="timeFormat"
			v-bind="attrsTime"
			prefix-icon=""
			start="06:00"
			step="00:15"
			end="23:59">
		</el-time-select>

	</div>
	<el-date-picker
		v-else
		ref="datePicker"
		v-model="valueData"
		v-bind="attrsDateCustom"
		class="qw-date-picker-root"
		:class="[{'pointer': !readonly, 'borderDotted': borderDotted, 'input-background': !hideInputBackground}]"
		:style="contentStyle"
		:format="format"
		:type="type"
		:readonly="readonly"
		:disabled="disabled"
		:placeholder="placeholder"
		@change="onDateChanged">
	</el-date-picker>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {delay} from "@/utils/helpers";

dayjs.extend(customParseFormat);

export default {
	name: "QwDatePicker",
	extends: BaseVModelView,

	props: {
		pickAsUTCDate: {Boolean, default: false},
		readonly: {Boolean, default: false},
		disabled: {Boolean, default: false},
		placeholder: {String, default: "Pick a date"},
		placeholderTime: {String, default: "Pick a time"},
		borderDotted: Boolean,
		hideInputBackground: Boolean,
		type: String,
		format: {String, default: "YYYY-MM-DD"},
		timeFormat: {String, default: "hh:mm A"},
		contentStyle: String,
		pickerOptions: {Object, default: () => ({})},
		disablePastDates: Boolean,
		disableFutureDates: Boolean,
		disabledDate: Function,
		initialView: String,
	},

	data() {
		return {
			dateFormatInternal: "YYYY-MM-DD",
			timeFormatInternal: "hh:mm A",
			isDateSelected: false,
			isTimeSelected: false,
			// dateValue: new Date(),
			// timeValue: 0,
		}
	},

	inheritAttrs: false,

	mounted(){
		if(this.modelValue){
			this.isDateSelected = true
			this.isTimeSelected = true
		}
	},


	methods: {


		notifyDateChanged() {

		},

		formatDataIn(data) {
			// if(this.isDateTimePicker){
				// data =
			// }
			return data
		},

		onDateChanged(){
			this.isDateSelected = true
			this.isTimeSelected = true
			this.notifyValueChanged()
		},

		formatDataOut(date) {
			console.log("QwDatePicker.formatDataOut: date = ", date)
			if(date && !Array.isArray(date)){

				date = dayjs(date).toDate()
				if (this.pickAsUTCDate) {
					let offset = -date.getTimezoneOffset()
					date = dayjs(date).add(offset, "minute").toDate()
					console.log("QwDatePicker.formatDataOut: offset = ", offset)
				}
				console.log("QwDatePicker.formatDataOut: date = ", date)
			}
			return date
		},

		getDatePicker(){
			return this.$refs.datePicker
		},

		focus(){
			this.$refs.datePicker.focus()
		},

		syncDateFromDateTimeUI(){


		},

		getTimestampByFormat(timestamp, format){
			return dayjs(dayjs(timestamp || 0).format(format), format).valueOf() || 0
		},
		hourMinToTsFromDate(date){
			return (date.hour() * 60 + date.minute()) * 60 * 1000
		},

		async onDatePickerFocus(){
			await delay(10)
			let elements = document.querySelectorAll('[aria-hidden="false"] .el-date-picker__header-label')
			console.log("onDatePickerFocus: document.getElementsByClassName(\"el-date-picker__header-label\") = ", elements, ", this.initialView = ", this.initialView)
			// console.log("this.$refs.datePickerRowItem = ", this.$refs.datePickerRowItem.getDatePicker())
			if(this.initialView === "year"){
				console.log("onDatePickerFocus: year, elements[0] = ", elements[0])
				elements[0].click()
				// this.$refs.datePickerRowItem.getDatePicker().picker.showYearPicker()// = "year"
			} else if(this.initialView === "month"){
				console.log("onDatePickerFocus: month, elements[1] = ", elements[1])
				elements[1].click()
				// this.$refs.datePickerRowItem.getDatePicker().picker.showMonthPicker()
			}
		},

		disableDate(time) {
			let isPastDate = false
			let isFutureDate = false
			let disableDate = false
			if(this.disabledDate){
				disableDate = this.disabledDate(time)
			}

			if (this.disablePastDates) {
				let startOfToday = dayjs().startOf('day').valueOf()
				isPastDate = time.getTime() < startOfToday
			}
			if (this.disableFutureDates) {
				let startOfTomorrow = dayjs().add(1, 'day').startOf('day').valueOf()
				isFutureDate = time.getTime() >= startOfTomorrow
			}
			return disableDate || this.disablePastDates && isPastDate || this.disableFutureDates && isFutureDate
		}

	},

	computed: {
		// v-bind="pickerOptionsComputed"

		attrsDateCustom(){
			return {
				...this.attrsNoListeners,
				disabledDate: this.disableDate.bind(this),
				...this.pickerOptions,
				// shortcuts: [{
				// 	text: 'Today',
				// 	onClick(picker) {
				// 		picker.$emit('pick', new Date());
				// 	}
				// }, {
				// 	text: 'Tomorrow',
				// 	onClick(picker) {
				// 		const date = new Date();
				// 		date.setTime(date.getTime() + 3600 * 1000 * 24);
				// 		picker.$emit('pick', date);
				// 	}
				// }, {
				// 	text: 'Next week',
				// 	onClick(picker) {
				// 		const date = new Date();
				// 		date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
				// 		picker.$emit('pick', date);
				// 	}
				// }, {
				// 	text: 'Next month',
				// 	onClick(picker) {
				// 		const date = new Date();
				// 		date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
				// 		picker.$emit('pick', date);
				// 	}
				// }, {
				// 	text: 'Next quarter',
				// 	onClick(picker) {
				// 		const date = new Date();
				// 		date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 3);
				// 		picker.$emit('pick', date);
				// 	}
				// }]
				onFocus: this.onDatePickerFocus
			}

		},

		isDateTimePicker() {
			return this.type === "datetime";
		},

		attrsTime(){
			return {
				...this.attrsNoListeners,
				// format: this.timeFormat,
			}
		},

		dateValue:{
			get(){
				return this.valueData && this.isDateSelected ? dayjs(this.valueData).toDate() : null
			},
			set(val){
				console.log("QwDatePicker.dateValue.set: val = ", val)
				console.log("QwDatePicker.dateValue.set: this.valueData = ", this.valueData)
				if(val){
					this.valueData = this.getTimestampByFormat(val, this.dateFormatInternal) + this.hourMinToTsFromDate(dayjs(this.valueData || 0))
					this.isDateSelected = true
					if(!this.isTimeSelected){
						this.$refs.timePicker.focus()
					}
				} else {
					this.valueData = null
					this.isDateSelected = false
					this.isTimeSelected = false
				}



				if(this.isDateAndTimeSelected || this.isDateAndTimeNotSelected) {
					this.notifyValueChanged()
				}
			}
		},
		timeValue:{
			get(){
				return this.valueData && this.isTimeSelected ? dayjs(this.valueData).format(this.timeFormat) : ""
			},
			set(val){
				console.log("QwDatePicker.timeValue.set: val = ", val)
				if(val){
					let dateTs = this.getTimestampByFormat(this.valueData, this.dateFormatInternal)
					let timeTs = this.hourMinToTsFromDate(dayjs(val, this.timeFormatInternal))
					console.log("QwDatePicker.timeValue.set: dateTs = ", dateTs)
					console.log("QwDatePicker.timeValue.set: timeTs = ", timeTs)

					if(dateTs < 0){
						timeTs = dayjs(val, this.timeFormatInternal).valueOf() //this reverts to today
						console.log("QwDatePicker.timeValue.set: timeTs2 1= ", timeTs)

					}

					this.valueData = dateTs + timeTs
					this.isTimeSelected = true
					if(!this.isDateSelected){
						this.$refs.datePicker.focus()
					}

				} else {
					this.valueData = null
					this.isDateSelected = false
					this.isTimeSelected = false
				}
				console.log("QwDatePicker.timeValue.set: this.valueData = ", this.valueData)
				if(this.isDateAndTimeSelected || this.isDateAndTimeNotSelected){
					this.notifyValueChanged()
				}
			}
		},

		isDateAndTimeSelected(){
			return this.isTimeSelected && this.isDateSelected
		},
		isDateAndTimeNotSelected(){
			return !this.isTimeSelected && !this.isDateSelected
		}
	},


}
</script>

<style lang="scss">

.qw-date-picker-root{

	flex-grow: 1;

	.qw-date-picker__date-select{

	}

	.qw-date-picker__time-select{
		width: 200px;
	}



	.qw-select-root{
		//height: px-to-rem(40);//need to maintain variable height in case of multiple values
		line-height: px-to-rem(40);
		.el-input{
			//padding: 0.5rem;
		}
		.el-select__tags{
			//padding-bottom: 4px;
			.el-tag--small{
				height: 18px;
			}

			.el-select__input{
				margin-left: 0;
				border: none !important;
			}
		}
	}
}



</style>
